import api from "common/utils/api";

/**
 * Masthead Promotion Count Loader
 * Handles loading and displaying promotion count badge in the masthead user dropdown
 */
class MastheadPromotionCount {
  constructor() {
    this.countBadge = document.querySelector(".js-promotions-count");
    this.countText = document.querySelector(".js-promotions-count-text");
    this.init();
  }

  init() {
    if (!this.countBadge || !this.countText) {
      return;
    }

    this.loadPromotionCount();
  }

  /**
   * Loads promotion count from API and updates the UI
   * @return {Promise<void>}
   */
  async loadPromotionCount() {
    try {
      const data = await api.account.promotions.count();

      if (data.success && data.count > 0) {
        this.showPromotionCount(data.count);
      }
    } catch (error) {
      console.error("Error loading promotion count:", error);
      // Fail silently - don't show error to user for non-critical functionality
    }
  }

  /**
   * Updates the UI to show the promotion count
   * @param {number} count - The number of promotions
   */
  showPromotionCount(count) {
    if (this.countText && this.countBadge) {
      this.countText.textContent = count.toString();
      this.countBadge.classList.remove("tw-hidden");
    }
  }
}

// Export init function following masthead component pattern
export default () => {
  // Only initialize if user is logged in (elements exist)
  if (document.querySelector(".js-promotions-count")) {
    // eslint-disable-next-line no-new
    new MastheadPromotionCount();
  }
};
